import React from 'react';
import * as Styled from './Panel.styled';
import { PanelBreakpointValue, PanelProps } from './Panel.type';
import withDefaultProps from '../../hoc/withDefaultProps';
import Text from '../Text/Text';

const getPanelSpacingsBreakpoints = (
  xs?: PanelBreakpointValue,
  sm?: PanelBreakpointValue,
  md?: PanelBreakpointValue,
  lg: PanelBreakpointValue = 'M24',
) => ({
  xs: xs || sm || md || lg,
  sm: sm || md || lg,
  md: md || lg,
  lg: lg,
});

export const Panel = (props: PanelProps) => {
  const { spacing, ...rest } = props;
  return (
    <Styled.Panel
      spacing={{
        ...getPanelSpacingsBreakpoints(
          spacing?.xs,
          spacing?.sm,
          spacing?.md,
          spacing?.lg,
        ),
      }}
      {...rest}
    />
  );
};

Panel.Title = withDefaultProps(Text, {
  as: 'h2',
  weight: 'bold',
  size: 'l',
  color: '#333',
});
export default Panel;
